
import { Vue } from 'vue-class-component'
export default class LoadingSpinner extends Vue {}
